// Vendors
import $ from 'jquery';

function playVideo(videoId) {
  let iframe = document.createElement('iframe');
  let videoSrc = 'https://www.youtube.com/embed/';
  videoSrc += videoId;
  videoSrc += '?autoplay=1';
  iframe.setAttribute('src', videoSrc);
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute(
    'allow',
    'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
  );
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('width', '100%');
  iframe.setAttribute('height', '100%');
  let containerId = 'videoContainer_' + videoId;
  let container = document.getElementById(containerId);
  container.innerHTML = '';
  container.appendChild(iframe);
}

$('.video-container').on('click', (event) => {
  event.preventDefault();
  let videoId = $(event.currentTarget).attr('youtube-id');
  playVideo(videoId);
});
